/**
 * Convert an unknown error value to a user-displayable string.
 */
export function stringifyError(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
